import React, { Component, useState, useEffect } from "react";
import { track } from "../../api/heap";
import { connect } from "react-redux";
import Back from "../../assets/Back";
import * as actions from "../../state/actions/onboarding";
import isKey from "../../utilities/keyboard-events";

///////////////////////////////////////////////////////////////////////////////
// code ripped from components/processing/ProcessingIdentity.js

import Fade from "../common/Fade";
import CheckmarkLight from "../../assets/CheckmarkLight";
import Portrait from "../../assets/Portrait";

const Delayer = ({ callback }) => {
  const [percentage, setPercentage] = useState(0);

  // try to be realistic-ish
  useEffect(() => {
    if (percentage < 100) {
      setTimeout(
        () => setPercentage(percentage + 5 + Math.random() * 10),
        300 + Math.random() * 300
      );
    }
  });

  const renderProgressCircle = () => {
    return (
      <div class="progress">
        <svg
          class="progress-circle"
          width="200px"
          height="200px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="progress-circle-back" cx="80" cy="80" r="74"></circle>
          <circle
            class="progress-circle-prog"
            style={{
              strokeDasharray: `${percentage * 4.65} 999`,
              transition: "stroke-dasharray 0.3s linear 0s"
            }}
            cx="80"
            cy="80"
            r="74"
          ></circle>
        </svg>
      </div>
    );
  };

  const finished = percentage > 100;

  return (
    <div className="outerStack-mobile sm:outerStack">
      <div className="innerStack">
        {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
        <div className="stepDescriptionText">
          {finished ? "Good to Go!" : "Building Your Profile"}
        </div>
        <div style={{ maxHeight: 220 }}>
          <div style={{ margin: "0 auto" }}>{renderProgressCircle()}</div>
          {!finished ? (
            <Portrait
              style={{ position: "relative", top: -120, margin: "auto" }}
            />
          ) : (
            <Fade show={!finished} hideOnly duration={0.8} className="h-0">
              <Portrait
                className="fadeOut"
                style={{ position: "relative", top: -120, margin: "auto" }}
              />
            </Fade>
          )}
          <Fade show={finished} duration={1.2}>
            <CheckmarkLight
              style={{
                position: "relative",
                top: -130,
                margin: "auto",
                height: 100,
                width: 100
              }}
            />
          </Fade>
        </div>

        {!finished && (
          <div className="textContainer" style={{ maxWidth: 240 }}>
            <span>Please wait while we build your financial profile</span>
          </div>
        )}
        {finished && (
          <a onClick={callback}>
            <input
              type="button"
              name="button"
              value="Continue"
              className="continueButton cursor-pointer"
            />
          </a>
        )}
      </div>

      <div className="bottomBar md:absolute inset-x-0 bottom-0">
        <div className="bottomBarText-mobile sm:bottomBarText">
          <div>
            <div>
              <input
                type="button"
                name="button"
                value="Cancel"
                className="backButton"
                onClick={() => {
                  window.alert(
                    "You must wait for the current process to finish"
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

///////////////////////////////////////////////////////////////////////////////

class Student extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      delaying: false
    };
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }
  }

  componentDidUpdate() {
    if (this.state.delaying) {
      this.delayFinished();
    }
  }
  
  handlePrevious = () => {
    this.props.previousStep();
  };

  handleNext = () => {
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    if (this.props.step.stepIsComplete) {
      this.setState({ delaying: true });
    } else {
      this.setState({ error: "You must answer the question to continue" });
    }
  };

  delayFinished = () => {
    this.props.updateUserDatabase(this.props.user.email, {
      isStudent: this.props.user.student,
      applicationProgress: {
        lastCompletedStep: 6,
        student: true,
        lastUpdated: new Date()
      }
    });
    this.props.nextStep();
  };

  renderError = message => <div style={{ color: "red" }}>{message}</div>;

  renderStudentButton = (text, selected, value) => {
    return (
      <button
        className={`rounded-full flex justify-center p-3 hover:text-primary ${selected &&
          "font-black"}`}
        style={{
          border: `3px solid ${selected ? "#26E3BA" : "transparent"}`,
          height: 50,
          width: 50,
          outline: "none",
          transition: "border 0.3s, color 0.3s"
        }}
        onClick={() => {
          track("ONBOARDING_STUDENT_STEP_SELECTED_OPTION", { value });
          this.props.updateUser({ student: value });
          this.props.updateStep("student", { stepIsComplete: true });
        }}
      >
        <span
          className="self-center"
          style={{ color: selected ? "#26E3BA" : "" }}
        >
          {text}
        </span>
        {/* this is a hack to preload the bold font and prevent jumpy layout */}
        <span className="font-black opacity-0 absolute">a</span>
      </button>
    );
  };

  renderQuestion = () => {
    const {
      handleNext,
      handlePrevious,
      renderError,
      renderStudentButton,
      state: { error },
      props: {
        step: { stepIsComplete },
        user: { student },
        networkingError
      }
    } = this;

    return (
      <div
        className="outerStack-mobile sm:outerStack"
        style={{ outline: "none" }}
        tabindex="0"
        autoFocus
        onKeyUp={e => {
          if (isKey(e, ["enter"])) {
            e.preventDefault();
            this.handleNext();
          }
        }}
      >
        <div className="innerStack">
          <div className="stepDescriptionText">
            Last question - are you a student?
          </div>
          {error && renderError(error)}
          {networkingError && renderError(networkingError)}

          <div className="flex justify-between w-7/12 mx-auto">
            {[{ text: "Yes", value: true }, { text: "No", value: false }].map(
              (option, index) =>
                renderStudentButton(
                  option.text,
                  option.value == student,
                  option.value
                )
            )}
          </div>

          <div>
            <input
              type="button"
              name="button"
              value="Continue"
              className="continueButton cursor-pointer"
              style={{
                backgroundColor: stepIsComplete ? "#26E3BA" : "gray"
              }}
              disabled={!stepIsComplete || this.state.transitioning}
              onClick={handleNext}
            />
          </div>

          <div className="bottomBar">
            <div className="bottomBarText-mobile sm:bottomBarText">
              <div onClick={handlePrevious}>
                {/* <Back className="backButtonIcon" /> */}
                <input
                  type="button"
                  name="button"
                  value="Back"
                  className="backButton"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if(this.state.delaying) {
      return null;
    }
    return this.renderQuestion()
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.student,
    networkingError: state.register.networkingError
  }),
  actions
)(Student);
